// removed by extract-text-webpack-plugin
module.exports = {"page":"_3eWgKFdtz4L8NUlOQCg-2V","headLine":"_2zTWxT7pKc6hOznKLvXFWy","bottomLine":"LcXlb2RnBK5ZZPMdcMu8x","buttonContainer":"iiZ23eOz1FXaX8UWCyWo7","pagination":"_30o7Jl70WEvy-1SS--uHzI","optionContainer":"_1e5mLZfRmqDDG4RRQOkz3M","form":"ZyG5WQIbJbK2nhSfugRrS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Groups/GroupContacts.scss
// module id = 1350
// module chunks = 1